import type { OwnedShip } from "../../hooks";
import { EmptyState, HudDivider, ShipIcon } from "../shared";

interface ShipInventoryProps {
	ships: OwnedShip[];
	isLoading?: boolean;
}

export function ShipInventory({ ships, isLoading = false }: ShipInventoryProps) {
	if (isLoading) {
		return (
			<section className="ship-inventory">
				<HudDivider label="YOUR FLEET" />
				<div className="ship-inventory__loading">Loading fleet...</div>
			</section>
		);
	}

	if (ships.length === 0) {
		return (
			<section className="ship-inventory">
				<HudDivider label="YOUR FLEET" />
				<EmptyState
					icon="🚀"
					title="No ships yet"
					description="Acquire your first ship above to begin farming missions."
				/>
			</section>
		);
	}

	return (
		<section className="ship-inventory">
			<HudDivider label="YOUR FLEET" count={ships.length} />
			<div className="ship-dock">
				{ships.map((ship) => (
					<div key={ship.tokenId.toString()} className="ship-dock__slot">
						<ShipIcon tier={ship.tier} size="md" />
						<span className="ship-dock__id">#{ship.tokenId.toString()}</span>
					</div>
				))}
			</div>
		</section>
	);
}
